if (typeof window.BackInStock == 'undefined') {
  window.BackInStock = {};
}

BackInStock.init = function (swat) {
  BackInStock.swat = swat;
};

BackInStock.subscribe = function (email, product, signup) {
  return new Promise((resolve, reject) => {
    const onSuccess = function (response) {
      resolve(response);
    };

    const onError = function (error) {
      console.error('There was an Error while subscribing the email for the alert.', error);

      reject(error);
    };

    BackInStock.swat.sendWatchlist(email, 'email', product, onSuccess, onError, signup);
  });
};

if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStockAlert extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.productUrl = this.dataset.productUrl;
        this.imageUrl = this.dataset.imageUrl;
        this.price = this.dataset.price;
        this.event = this.dataset.event;

        this.button = this.querySelector('.product-form__submit');
        this.email = this.querySelector('.form__input');

        this.form = this.querySelector('.backinstock__form');
        this.success = this.querySelector('.backinstock__success');

        this.subscribe = this.querySelector('.form__checkbox');

        this.wishlist = document.querySelector(`#ProductWishlistButton-${this.sectionId}`);

        this.button.addEventListener('click', this.submit.bind(this));

          // Handle marketing checkbox subtitle visibility
        this.setupMarketingCheckbox();
      }

        setupMarketingCheckbox() {
  const marketingCheckbox = this.querySelector('#BackInStock-marketing');
  const details = this.querySelector('#BackInStock-details');

  if (marketingCheckbox && details) {
    const toggleDetails = () => {
      if (marketingCheckbox.checked) {
        details.classList.remove('hidden');
      } else {
        details.classList.add('hidden');
      }
    };

    // Listen for checkbox changes
    marketingCheckbox.addEventListener('change', toggleDetails);

    // Set initial state
    toggleDetails();
  }
}


      submit(e) {
        e.preventDefault();

        if (!this.email.checkValidity()) {
          this.email.reportValidity();
        } else {
          this.button.classList.add('loading');

          let productData = {
            epi: this.variantId,
            empi: this.productId,
            du: this.productUrl,
            iu: this.imageUrl,
            pr: this.price,
            et: this.event,
          };

          BackInStock.subscribe(this.email.value, productData, this.subscribe.checked ? 1 : 0).then((response) => {
            this.form.classList.add('hidden');
            this.success.classList.remove('hidden');

            if (this.wishlist) {
              this.wishlist.textContent = '';
            }
          });
        }
      }
    }
  );
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(BackInStock.init);
